import { TimeSpan } from "@bryntum/schedulerpro";

export default class TimeRange extends TimeSpan {
  static get $name() {
    return "TimeRange";
  }

  static get fields() {
    return [
      { name: "recordType", persist: false }
    ]
  }
}
